import * as R from 'ramda'

const isNilOrEmpty = R.anyPass([R.isNil, R.isEmpty])

export default isNilOrEmpty
